module.exports = __webpack_public_path__ + "img/Premium Icon.a06597dc.svg";